module.exports = __webpack_public_path__ + "img/landscape-morning.3d9e3bea.jpg";